import { render, staticRenderFns } from "./picinvitemanagetable.vue?vue&type=template&id=00bf473e&scoped=true&"
import script from "./picinvitemanagetable.vue?vue&type=script&lang=js&"
export * from "./picinvitemanagetable.vue?vue&type=script&lang=js&"
import style0 from "./picinvitemanagetable.vue?vue&type=style&index=0&id=00bf473e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bf473e",
  null
  
)

export default component.exports